import { useMemo, useState } from "react";
import { TDailySchedule, TDailyScheduleEntry } from "../types";
import { TScheduler } from "../types";
import { getShortDayName, getWeekDays } from "./utils";
import { HintDot } from "baseui/badge";
import DayItem from "./DayItem";
import { Button } from "baseui/button";
import { useGetLanguage } from "../../../../hooks/useGetLanguage";
import { styled, useStyletron } from "baseui";


const MobileView: React.FC<{
  days: TDailySchedule[],
  app: TScheduler,
  now: Date,
  onEventDeleted: (weekday: number, event: TDailyScheduleEntry) => void,
  onEventChanged: (weekday: number, event: TDailyScheduleEntry) => void,
}> = ({ days, app, now, onEventDeleted, onEventChanged }) => {

  const [css, theme] = useStyletron();
  const [selected, setSelected] = useState<number>(0);
  const { language } = useGetLanguage();
  const weekDays = getWeekDays();
  const items = useMemo(() => days.find(v => v.weekday === selected)?.entries ?? [],[selected,days])
  
  return (
    <MainContainer>
        <ButtonsContainer >
          {weekDays.map((x) => {
            const day = x;//.getDay();
            const isToday = now.getDay() === day;
            const items = days.find(v => v.weekday === day)?.entries ?? []
            const empty = items?.length === 0;
            return (<>
              {empty ?
                <HintDot color="warning">
                  <Button shape="circle" onClick={() => setSelected(day)} isSelected={selected === day} kind="secondary" size="compact">{getShortDayName(day, language)}</Button>
                </HintDot>
                :
                <>{
                  isToday ?
                    <HintDot color="positive">
                      <Button shape="circle" onClick={() => setSelected(day)} isSelected={selected === day} kind="secondary" size="compact">{getShortDayName(day, language)}</Button >
                    </HintDot>
                    : <Button shape="circle" onClick={() => setSelected(day)} isSelected={selected === day} kind="secondary" size="compact">{getShortDayName(day, language)}</Button>

                }</>
              }
            </>)
          })}
        </ButtonsContainer >

        <DayItem onEntryChanged={onEventChanged} onEntryDeleted={onEventDeleted} now={now} app={app} dayOfWeek={selected} items={items}></DayItem>
    </MainContainer>);
};

export default MobileView;

const MainContainer = styled<'div',{}>("div", ({ $theme }) => ({
  height: '500px',
  display: 'flex',
  flexDirection: 'column',
  gap:  $theme.sizing.scale200,
  overflowX: 'auto',  
  justifyContent: 'flex-start'
}));
const ButtonsContainer = styled<'div',{}>("div", ({ $theme }) => ({
  height: 'auto',
  display: 'flex',
  flexDirection: 'row',
  gap:  $theme.sizing.scale200
}));


